module.exports = __webpack_public_path__ + "static/media/Dining2.36ddedbb.jpg";